import { Box, GlobalStyles } from '@mui/material';
import NProgress from 'nprogress';
import React, { useEffect } from 'react';
import 'nprogress/nprogress.css';

const LoadingScreen = ({ showSpinner = true, options = {} }) => {
    NProgress.configure({
        showSpinner,
        ...options,
    });

    useEffect(() => {
        NProgress.start();
        return () => {
            NProgress.done();
        };
    }, [showSpinner, options]);
    return (
        <>
            <GlobalStyles
                styles={{
                    '#nprogress .spinner': {
                        position: 'fixed',
                        top: '50% !important',
                        left: '50% !important',
                        right: 'auto !important',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 1031,
                    },
                    '#nprogress .spinner-icon': {
                        width: 50,
                        height: 50,
                        boxSizing: 'border-box',
                        border: '2px solid transparent',
                        borderLeftColor: 'rgba(6, 29, 42, 1)',
                        borderTopColor: 'rgba(10, 72, 107, 1)',
                        borderRadius: '50%',
                        animation: 'nprogress-spinner 400ms linear infinite',
                    },
                    '@keyframes nprogress-spinner': {
                        '0%': { transform: 'rotate(0deg)' },
                        '100%': { transform: 'rotate(360deg)' },
                    },
                }}
            />
            <Box
                sx={{
                    position: 'fixed',
                    inset: 0,
                    bgcolor: 'rgba(0,0,0,0.12)',
                    zIndex: 1029,
                }}
            />
        </>
    );
};

export default LoadingScreen;
